import { PedidosAcumulativosManager } from "./PedidosAcumulativosManager";

export function PedidosAcumulativosTab() {
  return (
    <div className="p-6">
      <PedidosAcumulativosManager />
    </div>
  );
}
